import React from 'react';
import { TopNav } from '../components/TopNav';
import { Hero } from '../components/Hero';
import { Stores } from '../components/Stores';
import { Problem } from '../components/Problem';
import { HowItWorks } from '../components/HowItWorks';
import { Benefits } from '../components/Benefits';
import { RoiCalculator } from '../components/RoiCalculator';
import { UssdSimulator } from '../components/UssdSimulator';
import { Safety } from '../components/Safety';
import { Pricing } from '../components/Pricing';
import { Waitlist } from '../components/Waitlist';
import { Footer } from '../components/Footer';
export function Marketing() {
  return <div className="min-h-screen flex flex-col w-full bg-ink font-sans text-bone selection:bg-mint selection:text-ink" data-id="element-1004">
      <TopNav data-id="element-1005" />
      <main className="flex-1" data-id="element-1006">
        <Hero data-id="element-1007" />
        <Stores data-id="element-1008" />
        <Problem data-id="element-1009" />
        <HowItWorks data-id="element-1010" />
        <Benefits data-id="element-1011" />
        <RoiCalculator data-id="element-1012" />
        <UssdSimulator data-id="element-1013" />
        <Safety data-id="element-1014" />
        <Pricing data-id="element-1015" />
        <Waitlist data-id="element-1016" />
      </main>
      <Footer data-id="element-1017" />
    </div>;
}